import { queryClient } from "@impero-com/common/utils/query_client";
import { useMutation } from "@tanstack/react-query";

import { TestingActivityReassignment } from "api/generated/model";
import { patchTestingActivitiesReassign } from "api/generated/testing-activities/testing-activities";
import { getGetTestingProgramsTestingProgramIdActivitiesQueryKey } from "api/generated/testing-programs/testing-programs";

interface ReassignTestingActivityMutationVars {
    payload: TestingActivityReassignment[];
}

export const useReassignTestingActivitiesMutation = () =>
    useMutation({
        mutationFn: async (vars: ReassignTestingActivityMutationVars) => {
            // Returns the distinct testing program ids affected by the reassignment.
            const response = await patchTestingActivitiesReassign(vars.payload);
            return response.data;
        },
        onSuccess: (affectedProgramIds) => {
            affectedProgramIds.forEach((testingProgramId) => {
                queryClient.invalidateQueries({
                    queryKey:
                        getGetTestingProgramsTestingProgramIdActivitiesQueryKey(
                            testingProgramId
                        ),
                });
            });
        },
    });
